export default () => ({
  item: {}
})
